import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class ClearPrioFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'ClearPrioFilter';

    public constructor() {
        super(ClearPrioFilter.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState): void => {
    state.filterState.prioIds = [];
};

//@ts-ignore
registerReducer(ClearPrioFilter.ACTION_TYPE, reducer);